import moment from 'moment';
import { useMemo } from 'react';

import { useTaskListContext } from '@app/providers/TaskListProvider';

export const useMonthGrid = () => {
  const { monthWeeks, currentDate } = useTaskListContext();
  const currentMonth = useMemo(() => {
    const { month, year } = currentDate;
    const isValid =
      moment(`${year}-${month}`, 'YYYY-MM').isValid() &&
      !isNaN(month) &&
      !isNaN(year);
    if (!isValid) {
      const currentDate = {
        year: moment().year(),
        month: moment().month() + 1,
      };
      return currentDate;
    }

    return { month, year };
  }, [currentDate]);
  return { monthWeeks, currentMonth };
};
